import { useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from '../lib/react-redux-hooks';
import _ from 'lodash';

import * as types from '../actions/actionTypes';

export const useOpenSaveSearchDialogHook = () => {
  const dispatch = useDispatch();

  const {
    token,
    savedSearchesLoading,
    savedSearch = [],
    feedSearch = {},
  } = useSelector((state: any) => {
    return {
      token: state.auth.token,
      savedSearchesLoading: state.feed.savedSearchesLoading,
      savedSearch: state.feed.savedSearches.savedSearch || [],
      feedSearch: state.feed.feedSearch,
    };
  });

  const compareSearch = (search1: any, search2: any) => {
    // Delete any null/undefined properties and compare the object
    return _.isEqual(_.omitBy(search1, _.isNil), _.omitBy(search2, _.isNil));
  };

  const { isSaved, currentSearch } = useMemo(() => {
    let isSavedLocal = false;
    let currentSearchLocal = null;

    savedSearch.forEach((search: any) => {
      if (compareSearch(feedSearch, search.query)) {
        isSavedLocal = true;
        currentSearchLocal = search;
        return isSavedLocal;
      }
    });

    return { isSaved: isSavedLocal, currentSearch: currentSearchLocal };
  }, [feedSearch, savedSearch, savedSearch.length]);

  const saveSearchHandler = useCallback(() => {
    if (token) {
      if (!isSaved) {
        dispatch({
          type: types.OpenSaveSearchDialog,
        });
      } else {
        const searchId = _.get(currentSearch, 'id', null);

        if (searchId) {
          dispatch({
            type: types.OpenDeleteSearchDialog,
            searchId: searchId,
          });
        }
      }
    } else {
      dispatch({
        signupSubtext: `Sign up to save your search and get updates about the latest properties`,
        type: types.OpenSignupDialog,
        signupCallback: () => {
          dispatch({
            type: types.OpenSaveSearchDialog,
          });
        },
      });
    }
  }, [dispatch, token, isSaved, currentSearch]);

  return {
    savedSearch: isSaved,
    savedSearchesLoading,
    saveSearchHandler,
  };
};
